import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastProvider } from "./components/toast/ToastProvider.tsx";
import "./index.css";
import Login from "./components/login/Login.tsx";
import Callback from "./components/callback/Callback.tsx";
import UpdateStudyConfiguration from "./components/updatestudyconfiguration/UpdateStudyConfiguration.tsx";
import CreateStudyConfiguration from "./components/createstudyconfiguration/CreateStudyConfiguration.tsx";
import Layout from "./components/layout/Layout.tsx";
import AssignedStudies from "./components/assignedstudies/AssignedStudies.tsx";
import { UserProvider } from "./contexts/UserContext.tsx";
import UnderDevelopment from "./components/underdevelopment/UnderDevelopment.tsx";
import XptFileUpload from "./components/xptfileupload/XptFileUpload.tsx";
import ValueLevelVariables from "./components/valuelevelvariables/ValueLevelVariables.tsx";
import ExcelViewer from "./components/modal/excel-viewer/ExcelViewer.tsx";
const App: React.FC = () => {
  return (
    <UserProvider>
      <div className="min-h-screen bg-gray-50">
        <ToastProvider>
          <Router>
            <main className="container mx-auto px-4 py-8 app-main">
              <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Navigate to="/" replace />} />
                <Route path="/callback" element={<Callback />} />
                <Route path="/defineui" element={<Layout />}>
                  <Route path="assigned-studies" element={<AssignedStudies />} />
                  <Route path="edit-study-configuration" element={<UpdateStudyConfiguration />} />
                  <Route path="create-study-configuration" element={<CreateStudyConfiguration />} />
                  <Route path="issue-management" element={<UnderDevelopment />} />
                  <Route path="xptfileupload" element={<XptFileUpload />} />
                  <Route path="value-level-variables" element={<ValueLevelVariables />} />
                  <Route path="*" element={<UnderDevelopment />} />

                </Route>
                <Route path="/defineui/excel-viewer/:revisionNumber" element={<ExcelViewer />} />
              </Routes>
            </main>
          </Router>
        </ToastProvider>
      </div>
    </UserProvider>
  );
};

export default App;